export default [
  {
    path: '/admin/defines/related-person-types',
    name: 'RelatedPersonTypes',
    component: () => import('@/views/Admin/Defines/Related_person_types/Index.vue'),
    meta: {
      pageTitle: 'İlgili Kişi Ünvanları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/related-person-types/add',
    name: 'RelatedPersonTypeAdd',
    component: () => import('@/views/Admin/Defines/Related_person_types/Add.vue'),
    meta: {
      pageTitle: 'İlgili Kişi Ünvanları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/related-person-types',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/related-person-types/edit/:id',
    name: 'RelatedPersonTypeEdit',
    component: () => import('@/views/Admin/Defines/Related_person_types/Edit.vue'),
    meta: {
      pageTitle: 'İlgili Kişi Ünvanları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/related-person-types',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
